<template>
  <div class="station-alarm-container">
    <div class="alarm-data-query">
      <template v-for="(cmd, idx) in canDoCmds">
        <AuthButton v-if="idx < cmdcnt" :key="idx" :opCode="cmd.opcode" size="default" style="margin-right: 5px" @click="clickCmd(cmd)">{{showLang(cmd.lang)}}
        </AuthButton>
      </template>
      <Dropdown style="margin-right: 10px" v-if="canDoCmds.length > cmdcnt">
        <Button type="primary">
          {{showLang('com.op.other')}}<Icon type="ios-arrow-down"></Icon>
        </Button>
        <div slot="list" class="btns-flex" style="width: 500px">
          <template v-for="(cmd, idx) in canDoCmds">
            <AuthButton v-if="idx >= cmdcnt" :key="idx" :opCode="cmd.opcode" size="default" style="margin: 5px" @click="clickCmd(cmd)">{{showLang(cmd.lang)}}
            </AuthButton>
          </template>
        </div>
      </Dropdown>
      <Button opCode='sc' type="success" size="default" style="margin-right: 5px" @click="sendFailed">{{showLang('com.but.failed.resend')}}</Button>
      <Button opCode='sc' type="success" size="default" style="margin-right: 5px" @click="exportResult">{{showLang('com.op.export.results')}}</Button>
      <Checkbox v-model="clearOldLog">{{showLang('com.lamp.is.ins')}}</Checkbox>
      <Checkbox v-model="isScreenSelected">{{showLang('com.lamp.is.screen')}}</Checkbox>
    </div>
    <div class="alarm-data-area" ref="table">
      <vxe-table border resizable show-overflow show-header-overflow keep-source ref="chkTable" :key="dataRefresh"
        @checkbox-change="selectChangeEvent" :data="devices" :height="tabHeight" :row-config="{isHover: true}"
        :checkbox-config="{checkField: 'checked',}">
        <vxe-column type="checkbox" width="60"></vxe-column>
        <vxe-column field="pname" :title="showLang('com.tab.title')" width="250" sortable header-align="center">
        </vxe-column>
        <vxe-column field="sname" :title="showLang('com.site.name')" width="250" sortable header-align="center">
        </vxe-column>
        <vxe-column field="dcode" :title="showLang('com.export.cn.id')" width="200" sortable header-align="center">
        </vxe-column>
        <vxe-column field="message" :title="showLang('com.ins.result')" header-align="center" sortable></vxe-column>
      </vxe-table>
    </div>
    <ModalArgEdit v-model="showArgModal" :command="cmdItem" @saved="argsSaved" />
    <ModalWaiting v-model="showWaitingModal" :item="cmdItem" />
    <ModalCheckAuth v-model="showCheckAuthModal" :users="checkAuthModalUsers" @checked="cmdAuthUserChecked" />
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import ModalArgEdit from './ModalArgEdit'
import ModalWaiting from './ModalWaiting'
import exportXlsx from '@/components/xlsx/exportXlsx'
import ModalCheckAuth from './ModalCheckAuth'
export default {
  name: 'CommandChannelIndex',
  components: {
    ModalArgEdit,
    ModalWaiting,
    ModalCheckAuth,
  },
  props: {
  },
  data() {
    return {
      filter: {
        stationId: 0,
        channel: 0,
        timeId: 0,
      },
      tabHeight: 600,
      originalDevices: [],
      isScreenSelected: false,
      clearOldLog: this.clearOldLogs,
      cmdType: 'monitor',
      showCheckAuthModal: false,
      checkAuthModalSuccessFunction: null,
      checkAuthModalUsers: [],
      showWaitingModal: false,
      showArgModal: false,
      showPlanModal: false,
      showCreateModal: false,
      showStartOtaModal: false,
      cmdItem: { item: {}, other: {}, args: {} },
      cmdcnt: 8,
      items: [
        { needArgs: false, needPswd: false, code: 'forceReadLight', opcode: 'dcs',lang:'com.but.testing.Image', name: '召测镜像', flag: 1, img: this.img.light.factory.power.devOps.devOps1 },
        { needArgs: true, needPswd: true, code: 'handGroup11', opcode: 'dco',lang:'com.group.open', name: '组开', img: 'groupAdjust' },
        { needArgs: true, needPswd: true, code: 'handGroup10', opcode: 'dco',lang:'com.group.close', name: '组关', img: 'groupAdjust' },
        { needArgs: true, needPswd: true, code: 'handGroup1', opcode: 'dco',lang:'com.but.set.adjustment', name: '组调', img: 'groupAdjust' },
        { needArgs: true, needPswd: true, code: 'handAll1', opcode: 'dco',lang:'com.crowd.open', name: '群开', img: 'groupAdjust' },
        { needArgs: true, needPswd: true, code: 'handAll0', opcode: 'dco',lang:'com.crowd.level', name: '群关', img: 'groupAdjust' },
        { needArgs: true, needPswd: true, code: 'handAll', opcode: 'dco',lang:'com.crowd.tone', name: '群调', img: 'groupAdjust' },
        { needArgs: false, needPswd: false, code: 'getclock', opcode: 'dcs',lang:'com.but.get.read.clock', name: '读取时钟', flag: 1, img: this.img.light.factory.power.devOps.devOps8 },
        { needArgs: false, needPswd: true, code: 'setclock', opcode: 'dcc',lang:'com.but.get.Calibrate', name: '校准时钟', flag: 1, img: this.img.light.factory.power.devOps.devOps3 },
        { needArgs: true, needPswd: true, code: 'setallclock', opcode: 'dcc',lang:'com.but.all.Calibrate', name: '群校时钟', flag: 1, img: this.img.light.factory.power.devOps.devOps3 },
        { needArgs: false, needPswd: false, code: 'getWhite', opcode: 'dcs',lang:'com.but.get.whitelist', name: '查询白名单', flag: 1, img: this.img.light.factory.power.devOps.devOps7 },
        { needArgs: true, needPswd: true, code: 'setWhite', opcode: 'dcc',lang:'com.but.set.whitelist', name: '设置白名单', flag: 1, img: this.img.light.factory.power.devOps.devOps6 },
        { needArgs: true, needPswd: false, code: 'getCmdCount', opcode: 'dcs',lang:'com.but.get.ins.num', name: '查询指令数量', flag: 0, img: this.img.light.factory.power.devOps.devOps14 },
        { needArgs: true, needPswd: false, code: 'clearCmds', opcode: 'dcs',lang:'com.but.set.ins.clean', name: '清除指令队列', flag: 0, img: this.img.light.factory.power.devOps.devOps15 },
        { needArgs: false, needPswd: false, code: 'getInfo', opcode: 'dcs',lang:'com.but.get.deviceInfo', name: '设备信息', img: this.img.light.road.single.ctrl.info },
        { needArgs: false, needPswd: false, code: 'getSimInfo', opcode: 'dcs',lang:'com.but.card.info', name: '卡信息', img: this.img.light.road.single.ctrl.info },
        { needArgs: false, needPswd: false, code: 'getLoraWork', opcode: 'dcs',lang:'com.but.get.Lora.working', name: '查询Lora工作参数', img: this.img.light.road.single.ctrl.info },
        { needArgs: true, needPswd: true, code: 'setLoraWork', opcode: 'dcc',lang:'com.but.set.Lora.working', name: '设置Lora工作参数', img: this.img.light.road.single.ctrl.info },
        { needArgs: true, needPswd: true, code: 'startFindSlave', opcode: 'dcc',lang:'com.but.set.start.slaves', name: '开始查找从机', img: this.img.light.road.single.ctrl.info },
        { needArgs: true, needPswd: true, code: 'stopFindSlave', opcode: 'dcc',lang:'com.but.set.stop.slaves', name: '停止查找从机', img: this.img.light.road.single.ctrl.info },
        { needArgs: true, needPswd: true, code: 'startReadWhiteFlag', opcode: 'dcc',lang:'com.but.set.start.phase', name: '开始识别相位', img: this.img.light.road.single.ctrl.info },
        { needArgs: true, needPswd: true, code: 'stopReadWhiteFlag', opcode: 'dcc',lang:'com.but.set.stop.phase', name: '停止识别相位', img: this.img.light.road.single.ctrl.info },
        { needArgs: false, needPswd: false, code: 'getWhiteFlag', opcode: 'dcs',lang:'com.but.get.lamp.phase', name: '查询单灯相位', img: this.img.light.road.single.ctrl.info },
        { needArgs: false, needPswd: false, code: 'getMonitorSnId', opcode: 'dcs',lang:'com.but.get.SNID', name: '查SNID', img: this.img.light.road.single.ctrl.info },
        { needArgs: false, needPswd: false, code: 'getNetwork', opcode: 'dcs',lang:'com.but.get.work.network', name: '查询工作网络', img: this.img.light.road.single.ctrl.info },
        { needArgs: true, needPswd: true, code: 'setNetwork', opcode: 'dck',lang:'com.but.set.work.network', name: '设置工作网络', img: this.img.light.road.single.ctrl.info },
        { needArgs: false, needPswd: true, code: 'startNet', opcode: 'dck',lang:'com.but.Lora.networking', name: 'Lora组网', img: this.img.light.road.single.ctrl.info },
        { needArgs: true, needPswd: true, code: 'update', opcode: 'dck',lang:'com.but.ota', name: 'OTA升级', flag: 0, img: this.img.light.factory.power.devOps.devOps13 },
        { needArgs: true, needPswd: true, code: 'setLightUpdate', opcode: 'dck',lang:'com.but.set.light.upgrade', name: '设置单灯升级', flag: 0, img: this.img.light.factory.power.devOps.devOps13 },
        { needArgs: false, needPswd: false, code: 'getLightUpdate', opcode: 'dck',lang:'com.but.get.light.upgrade', name: '查询单灯升级', flag: 0, img: this.img.light.factory.power.devOps.devOps13 },
        { needArgs: true, needPswd: true, code: 'setSaveOtaFile', opcode: 'dck',lang:'com.but.set.ota.save.file', name: '设置保存OTA文件', flag: 0, img: this.img.light.factory.power.devOps.devOps13 },
        { needArgs: false, needPswd: false, code: 'getSaveOtaFile', opcode: 'dck',lang:'com.but.get.ota.save.file', name: '查询保存OTA文件', flag: 0, img: this.img.light.factory.power.devOps.devOps13 },
        { needArgs: true, needPswd: true, code: 'startSaveOtaFile', opcode: 'dck',lang:'com.but.start.ota.save.file', name: '开始下发OTA文件', flag: 0, img: this.img.light.factory.power.devOps.devOps13 },
        { needArgs: true, needPswd: true, code: 'reset', opcode: 'dco',lang:'com.but.set.reboot', name: '重启设备', flag: 2, img: this.img.light.factory.power.devOps.devOps4 },
        { needArgs: true, needPswd: true, code: 'init', opcode: 'dck',lang:'com.but.initialization', name: '初始化', flag: 2, img: this.img.light.factory.power.devOps.devOps4 },
      ],
      devices: [],
      dataRefresh: 0,
      arrCmds: [],
      cmdResults: {},
      timer: null,
    }
  },
  computed: {
    ...mapGetters('auth', ['funCodes','showLang']),
    ...mapState('auth', ['config']),
    ...mapState('cmd', ['cmdResultRefresh', 'commands', 'windowOnResize', 'clearOldLogs']),
    ...mapState('common', ['deviceTypes', 'productCodes']),
    ...mapState('group', ['selectedDevices', 'selectedNode']),
    selectedStations: function () {
      return this.selectedDevices;
    },
    canDoCmds: function () {
      let cmds = [];
      for (let cmd of this.items) {
        if(this.config.monitorShowCommands.indexOf(cmd.code) == -1)continue;
        if (this.funCodes(cmd.opcode)) cmds.push(cmd);
      }
      return cmds;
    }
  },
  watch: {
    clearOldLog() {
      this.$store.commit('cmd/setOldLogStatus', this.clearOldLog)
    },
    isScreenSelected() {
      this.screenSelected();
    },
    windowOnResize() {
      this.setTableHeight();
    },
    'filter.stationId'() {
      this.initList();
    },
    'filter.channel'() {
      this.initList();
    },
    'filter.timeId'() {
      this.initList();
    },
    selectedNode() {
      this.initList();
    },

  },
  mounted: function () {
    this.clearOldLog = this.clearOldLogs;
    setTimeout(this.setTableHeight, 100);
    this.initList();
    this.timer = setInterval(this.setCmdResult, 500);
    window.eventBus.$on('paramCommandComing', params => {
      // this.cmdResults[params.cmdId] = params;
      params.time = new Date().getTime();
      this.cmdResults[params.commandId] = params;
    })
  },
  destroyed: function () {
    window.eventBus.$off('paramCommandComing');
    clearInterval(this.timer);
  },
  methods: {
    screenSelected() {
      if (this.isScreenSelected) {
        this.devices = this.devices.filter(p => p.checked);
      } else {
        this.devices = this.originalDevices;
      }
    },
    setCmdResult: function(){
      for(let cmdId in this.cmdResults){
        let ds = this.devices.filter(p => p.cmdId == cmdId);
        if(ds.length == 0){
          if(new Date().getTime() - this.cmdResults[cmdId].time > 100000){
            console.log('cmd id time out');
            delete this.cmdResults[cmdId];
          }
          continue;
        }else{
          let item = this.cmdResults[cmdId];
          this.$set(ds[0], 'status', item.status);
          this.$set(ds[0], 'result', item.message);
          this.$set(ds[0], 'content', item.content);
          this.$set(ds[0], 'message', this.getCmdStatus(ds[0]));
          delete this.cmdResults[cmdId]
        }
      }
      this.calcSuccessRate();
    },
    calcSuccessRate: function(){
      let total = this.devices.length;
      let success = this.devices.filter(p => p.status == 9).length;
      let rate = 0;
      if(total <= 0){
        rate = 0;
      }else{
        rate = (success * 100 / total).toFixed(2);
      }
      window.eventBus.$emit('commandSuccessRateChanged', {total, success, rate });
    },
    selectChangeEvent({ rowIndex }) {
      this.$refs.chkTable.reloadRow(this.list, null, rowIndex)
    },
    exportResult: function () {
      let cmdData = [];
      this.devices.map(item => {
        cmdData.push({
          name: item.name,
          sname: item.sname,
          code: item.code,
          result: this.getCmdStatus(item)
        })
      });
      let tabHead = {
        name:this.showLang('com.ins.ch.name'),
        sname:this.showLang('com.site.name'),
        code:this.showLang('com.ins.last.id'),
        result:this.showLang('com.ins.result')
      }
      exportXlsx(cmdData, tabHead, this.showLang('com.ins.result'));
    },
    setTableHeight: function () {
      this.tabHeight = this.$refs.table.clientHeight - 5;
    },
    sendFailed: function () {
      let chks = this.$refs.chkTable.getCheckboxRecords();
      let cmds = [];
      let code = '';
      let args = {};
      for (let d of this.devices) {
        if ((d.status == 7 || d.status == 3 || d.status == 8) && chks.filter(p => p.id == d.id).length > 0) {
          this.$set(d, 'status', 0)
          this.$set(d, 'result', this.showLang('com.lighting.repeat.preparation'))
          this.$set(d, 'message', this.getCmdStatus(d))
          // cmds.push({id: d.id, code: d.cmd, name: d.name, deviceId: d.devId, args: d.args});
          cmds.push(d.id);
          code = d.cmd;
          args = d.args;
        } else if (this.clearOldLog) {
          this.$set(d, 'status', 0)
          this.$set(d, 'result', '')
        }
      }
      let cmd = {
        code: code,
        list: cmds,
        checkUserId: 0,
        args: args
      };
      setTimeout(() => {
        this.sendCommand(cmd);
      }, 500)
    },
    initList: function () {
      let groupId = 0, stationId = 0;
      if (this.selectedNode.type == this.productCodes.station) {
        stationId = this.selectedNode.id;
      } else {
        groupId = this.selectedNode.id;
      }
      this.$axios.post(`//${this.domains.trans}/station/config/QueryDevice`, { groupId, stationId, type: 2 }).then(res => {
        if (res.code == 0) {
          let devs = [];
          for (let p of res.data) {
            devs.push({id: p.id, pname: p.name, dname: p.deviceTypeName, type: p.type, dcode: p.code, devId: p.id, sname: p.stationName, cmdId: 0, cmd: '', name: '', args: {}, content: {}, time: 0, status: 0, result: '', message: '' })
          }
          this.$set(this, 'originalDevices', devs);
          this.$set(this, 'devices', devs);
          this.calcSuccessRate();
        }
      });
    },
    getCmdCount: async function (ids) {
      this.$axios.post(`//${this.domains.trans}/station/command/QueryGatewayCountOld`, { ids }).then(res => {
        if (res.code == 0) {
          for(let devId in res.data){
            let ds = this.devices.filter(p => p.devId == devId);
            if(ds.length == 0)continue;
            this.$set(ds[0], 'cmd', 'getCmdCount');
            this.$set(ds[0], 'status', 9);
            this.$set(ds[0], 'result', res.data[devId]);
            this.$set(ds[0], 'message', `${this.showLang('com.ins.get.result')}：${res.data[devId]}`);
          }
        }
      })
    },
    clearCmds: async function (ids) {
      this.$Modal.confirm({
        title: this.showLang('com.op.prompt'),
        content: this.showLang('com.ins.clean.ins.dev'),
        onOk: async () => {
          this.$axios.post(`//${this.domains.trans}/station/command/ClearGatewayQueueOld`, { ids }).then(res => {
            if (res.code == 0) {
              for(let devId in res.data){
                let ds = this.devices.filter(p => p.devId == devId);
                if(ds.length == 0)continue;
                this.$set(ds[0], 'cmd', 'clearCmds');
                this.$set(ds[0], 'status', 9);
                this.$set(ds[0], 'result', res.data[devId]);
                this.$set(ds[0], 'message', `${res.data[devId]}`);
              }
            }
          })
        },
      });
    },
    cmdAuthUserChecked: function(params){
      // console.log('auth user check result', params, this.checkAuthModalSuccessFunction);
      if(this.checkAuthModalSuccessFunction){
        this.checkAuthModalSuccessFunction(params);
      }
    },
    checkCmdAuth: function(type, cmdCode, checkOkFun){
      this.$axios.post(`//${this.domains.trans}/sys/setting/CheckCmdAuth`, {type, code: cmdCode}).then(res => {
        if(res.code != 0)return;
        if(!res.data.need){
          checkOkFun({userId: 0});
          return;
        }
        this.checkAuthModalSuccessFunction = checkOkFun;
        this.checkAuthModalUsers = res.data.users;
        this.showCheckAuthModal = true;
      });
    },
    clickCmd: function (params) {
      let chks = this.$refs.chkTable.getCheckboxRecords();
      if (chks.length == 0) {
        this.$Message.warning(this.showLang('com.ins.ch.select'));
        return;
      }
      if (params.code == 'getCmdCount') {
        let ids = chks.map(p => p.id);
        this.getCmdCount(ids);
        return;
      } else if (params.code == 'clearCmds') {
        let ids = chks.map(p => p.id);
        this.clearCmds(ids);
        return;
      } else if (params.needPswd || params.needArgs) {
        this.cmdItem = { paramsCode: params.code, code: params.code, name: params.name, pswd: params.needPswd, args: {} }
        this.showArgModal = true;
        return
      } else {
        this.checkCmdAuth(this.cmdType, params.code, (checkResult) => {
          if (this.clearOldLog) {
            for (let item of this.devices) {
              item.result = '';
              item.status = 0;
            }
          }
          let cmds = []
          let ds = {};
          for (let chk of chks) {
            if (chk.topId == 0) {
              ds[chk.sname] = chk.devId;
            } else {
              ds[chk.sname] = chk.topId;
            }
            // let args = {};
            // let code = params.code;
            // chk.result = this.showLang('com.lighting.ready.sending');
            // chk.status = 0;
            // chk.cmd = params.code;
            // chk.name = params.name;
            // chk.args = args;
            // chk.message = this.getCmdStatus(chk);
            // cmds.push({ id: chk.id, code: code, name: params.name, deviceId: chk.devId, checkUserId: checkResult.userId, args: args });
            cmds.push(chk.id);
          }
          let cmd = {
            code: params.code,
            list: cmds,
            checkUserId: checkResult.userId,
            args: params.args
          };
          this.sendCommand(cmd);
        });
      }
    },
    argsSaved: function (params) {
      this.checkCmdAuth(this.cmdType, params.paramsCode, (checkResult) => {
        this.showArgModal = false;
        if (this.clearOldLog) {
          for (let item of this.devices) {
            item.result = '';
            item.status = 0;
          }
        }
        let chks = this.$refs.chkTable.getCheckboxRecords();
        let cmds = []
        let ds = {};
        let ns = [];
        for (let chk of chks) {
          ns.push(chk.pname);
          ds[chk.name] = chk.devId;
          // let args = this.clone(params.args);// {channel: chk.channel}
          // args.channel = chk.channel;
          // params.args.channel = chk.channel;
          // if (params.code == 'handControl') {
          //   args.point = false;
          //   // args.expire = params.args.expire;
          //   // params.args.point = false;
          // } else if (params.code == 'setYearPlan') {
          //   // params.args.timeId = chk.timeId;
          //   args.timeId = chk.timeId;
          // } else if(params.code == "handGroup11" || params.code == "handGroup10"){
          //   params.code = "handGroup1";
          // } else if(params.code == "handAll1" || params.code == "handAll0"){
          //   params.code = "handAll";
          // }
          // chk.result = this.showLang('com.lighting.ready.sending');
          // chk.status = 0;
          // chk.cmd = params.code;
          // chk.name = params.name;
          // chk.args = args;
          // chk.message = this.getCmdStatus(chk);
          // cmds.push({ id: chk.id, code: params.code, name: params.name, deviceId: chk.devId, checkUserId: checkResult.userId, args: args });
          cmds.push(chk.id);
        }
        let cmd = {
          code: params.code,
          list: cmds,
          checkUserId: checkResult.userId,
          args: params.args
        };
        if (params.code == 'update') {
          this.$Modal.confirm({
            title: this.showLang('com.op.prompt'),
            content: this.showLang('com.ins.upgrade.device',ns),
            onOk: async () => {
              this.sendCommand(cmd);
            },
          });
        } else {
          if(params.code == 'startReadWhiteFlag'){
            this.cmdItem = {id: chks[0].id}
            this.showWaitingModal = true;
          }
          this.sendCommand(cmd);
        }
      });
    },
    getCmdStatus: function (cmd) {
      // console.log('cmd status changed', cmd)
      switch (cmd.status) {
        case 0: return `${cmd.result}`;
        case 2: return this.showLang('cmd.has.sent')+this.showLang('com.ins.dev.reply');
        case 3: return cmd.result;
        case 4: return this.showLang('com.ins.execution')+`：${cmd.content.pkg} / ${cmd.content.total}`;
        case 5: return this.showLang('com.ins.fail.retry')+`：${cmd.result}`;
        case 7: return this.showLang('cmd.has.timeout');
        case 8: return this.showLang('com.ins.fail')+`：${cmd.result}`;
        case 9: {
          // console.log('getCmdStatus', cmd)
          switch (cmd.cmd) {
            case 'clearCmds': return `${this.showLang('com.but.set.ins.clean')}：${cmd.result}`;
            case 'getCmdCount': return `${this.showLang('com.ins.queues.num')}：${cmd.result}`;
            case 'getclock': return `${this.showLang('com.ins.success')}：${cmd.content.nowTime}`;
            case 'getLightUpdate': return `${this.showLang('com.ins.success')}：${cmd.content.flag == 1 ? this.showLang('com.state.started') : this.showLang('com.state.no.started')}`;
            case 'setLightUpdate': return `${this.showLang('com.ins.success')}：${cmd.content.flag == 1 ? this.showLang('com.state.ok.started') : this.showLang('com.tab.no.file')}`;
            case 'getSaveOtaFile': return `${this.showLang('com.ins.success')}：${cmd.content.flag == 1 ? this.showLang('com.state.allow') : this.showLang('com.state.prohibit')}`;
            case 'getWhite': {
              if (cmd.type != 'st6038') {
                return `${this.showLang('com.ins.success')}，共${cmd.content.list.length}个：${cmd.content.list.join(', ')}`;
              }
              let cc = [];
              for (let item of cmd.content.list) {
                cc.push(`${item.id}:${item.no}`);
              }
              return `${this.showLang('com.ins.success')}，共${cmd.content.list.length}个：${cc.join(', ')}`;
            }
            case 'getInfo': return `${this.showLang('com.site.hw')}：${cmd.content.hardware}，${this.showLang('com.site.sw')}：${cmd.content.software}，${this.showLang('com.user.manufacturer')}：${cmd.content.manufacture}`;
            case 'getSimInfo': return `ICCID：${cmd.content.iccid}，IMEI：${cmd.content.imei}，RSSI：${cmd.content.rssi}`;
            case 'getNetwork': return `IP:${cmd.content.host}, ${this.showLang('com.ins.port')}:${cmd.content.port}, ${this.showLang('com.ins.heartbeat')}:${cmd.content.heart}s`;
            case 'getLoraWork': return `${this.showLang('cmd.content.ch')}：${cmd.content.channel}，${this.showLang('cmd.content.rate')}：${cmd.content.speed}`;
            default: return `${this.showLang('com.ins.success')} ${cmd.result}`;

          }
        }
      }
    },
    sendCommand: function(cmd){
      if(cmd.list.length == 0)return;
      this.$set(this, 'cmdResults', {});
      this.$axios.post(`//${this.domains.trans}/station/command/SendGatewayOld`, cmd).then(res => {
        if (res.code == 0) {
          // console.log('send cmd result', res.data, this.list);
          for (let item of res.data.list) {
            let ds = this.devices.filter(p => p.id == item.id);
            console.log('send cmd result', ds)
            if (ds.length == 0) continue;
            this.$set(ds[0], 'cmd', cmd.code);
            this.$set(ds[0], 'args', cmd.args);
            this.$set(ds[0], 'cmdId', item.success ? item.message : '');
            this.$set(ds[0], 'status', item.success ? 1 : 8);
            this.$set(ds[0], 'content', {});
            this.$set(ds[0], 'message', item.success ? '指令已进入发送队列' : item.message);
            // this.spanData();
          }
        }
      });
    },
  }
}
</script>
<style scoped>
.station-alarm-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-content: stretch;
  /* padding-right: 40px; */
  /* border: solid 1px red; */
}
.alarm-data-query {
  height: 40px;
  flex: none;
  background-color: white;
  margin: 3px 1px;
  display: flex;
  align-items: center;
  padding: 10px;
  white-space: nowrap;
}
.alarm-data-area {
  /* border: solid 1px red; */
  height: 100px;
  flex: auto;
  border-radius: 6px;
}
.tab-active {
  border: solid 1px rgb(135, 159, 224);
  background-color: rgb(135, 159, 224);
  color: white;
}
.station-alarm-tabcontent {
  height: 500px;
  flex: auto;
  /* border: solid 1px red; */
}
.btns-flex {
  width: 50%;
  display: flex;
  flex-wrap: wrap;
}
</style>